module.exports = __webpack_public_path__ + "img/header-engagementRingsModern.a98d975.webp";